import ApiClient from './ApiClient';

export const login = (credentials) => ApiClient.post('/login', credentials);

export const checkAuth = () => ApiClient.get('/check-auth');
